import { FormControlLabel } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import { styled } from '@mui/material/styles';
import { theme } from 'ui/theme-color';

export const MaterialCheckbox = styled(Checkbox)`
  *.material-symbols-outlined.checked-box-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;

    border: 2px solid ${theme.palette.colors.lightgrey};
    background-color: ${(props) => theme.palette[props.color].main} !important;
    color: ${(props) => theme.palette[props.color].contrastText};
    font-weight: 800;
    border-radius: 2px;
    padding: 1px;
    transition:
      background-color 0.2s ease,
      color 0.2s ease;
  }

  *.material-symbols-outlined.box-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;

    border: 2px solid ${theme.palette.colors.lightgrey};
    background-color: transparent;
    color: transparent;
    font-weight: 800;
    border-radius: 2px;
    padding: 1px;
    transition:
      background-color 0.2s ease,
      color 0.2s ease;
  }
`;

export const StyledFormControlLabel = styled(FormControlLabel)`
  .MuiFormControlLabel-label {
    font-size: 1rem;
    white-space: ${(props) => (props.nowrap ? 'nowrap' : 'normal')};
  }
`;
